import { Gift, Users, UserCheck, CalendarCheck } from "lucide-react";

import { CarregandoCards } from "@/components/carregando";

const meses = (n) => `${n} ${n === 1 ? "mês" : "meses"}`;

function Card({ icon: Icon, label, valor, hint, destaque }) {
  return (
    <div
      className={`rounded-xl border p-4 ${
        destaque
          ? "bg-gradient-to-br from-primary/10 to-primary/5 border-primary/30"
          : "bg-card"
      }`}
    >
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`w-4 h-4 ${destaque ? "text-primary" : "text-muted-foreground"}`} />
        <p className="text-sm font-medium text-muted-foreground">{label}</p>
      </div>
      <p className={`text-3xl font-extrabold ${destaque ? "text-primary" : ""}`}>{valor}</p>
      {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}

/**
 * Os quatro numeros do topo. "Meses a usar" vem primeiro e destacado porque e' o
 * unico que responde a pergunta que o lojista tem: quanto eu ja ganhei e ainda
 * nao gastei. Os outros tres dao contexto.
 */
export default function ResumoMeses({ resumo, loading }) {
  // Carregamento com cards (25/10/2026): peça compartilhada, no formato dos 4 cards.
  if (loading) {
    return <CarregandoCards quantos={4} className="grid grid-cols-2 lg:grid-cols-4 gap-4" altura="h-[134px]" />;
  }

  const disponiveis = resumo?.meses_disponiveis ?? 0;
  const usados = resumo?.meses_usados ?? 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Card
        icon={Gift}
        label="Meses grátis a usar"
        valor={meses(disponiveis)}
        hint={
          disponiveis > 0
            ? "Entram automaticamente nas próximas faturas"
            : "Indique alguém para começar a ganhar"
        }
        destaque
      />
      <Card
        icon={CalendarCheck}
        label="Meses já aproveitados"
        valor={meses(usados)}
        hint={usados > 0 ? "Faturas que saíram zeradas" : "Nenhum ainda"}
      />
      <Card
        icon={Users}
        label="Indicados"
        valor={resumo?.total_referred ?? 0}
        hint="Estabelecimentos que usaram seu código"
      />
      {/* `indicados_que_pagaram`, e nao `active_referred`: aquele conta status
          do tenant, entao loja em trial contaria como pagante. */}
      <Card
        icon={UserCheck}
        label="Já pagaram"
        valor={resumo?.indicados_que_pagaram ?? 0}
        hint="São estes que viraram meses grátis"
      />
    </div>
  );
}
